import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 1.333a.667.667 0 0 0-.667.667v2h-2.666v-.667a.666.666 0 1 0-1.334 0V4H8v-.667a.667.667 0 0 0-1.333 0V4H5.333v-.667a.667.667 0 1 0-1.333 0V4H2.667V2a.667.667 0 0 0-1.334 0v10.667a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2V2A.666.666 0 0 0 14 1.333m-.667 11.334a.667.667 0 0 1-.666.666H3.333a.667.667 0 0 1-.666-.666v-2H4v.666a.667.667 0 0 0 1.333 0v-.666h1.334v.666a.667.667 0 0 0 1.333 0v-.666h2.667v.666a.667.667 0 1 0 1.333 0v-.666h1.333zm0-3.334H12v-.666a.667.667 0 1 0-1.333 0v.666H8v-.666a.667.667 0 0 0-1.333 0v.666H5.333v-.666a.667.667 0 1 0-1.333 0v.666H2.667v-4H4V6a.667.667 0 0 0 1.333 0v-.667h1.334V6A.667.667 0 0 0 8 6v-.667h1.333V6a.667.667 0 1 0 1.334 0v-.667h2.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })